<template>
  <b-row class="switch-margin">
    <b-col class="d-flex align-items-center justify-content-center">
      <div
        class="switch-container"
        :style="{ '--background': backgroundColor, '--mobile-background': mobileBackgroundcolor }"
      >
        <button
          :style="{
            backgroundColor: value ? pillColor : activePillColor,
            color: value ? '#545454' : activePillTextColor
          }"
          class="rounded-pill px-3 py-2 text-center border-0"
          @click="value = false"
        >
          {{ $t('plans.common.cards.monthly') }}
        </button>
        <button
          :style="{
            backgroundColor: !value ? pillColor : activePillColor,
            color: !value ? '#545454' : activePillTextColor
          }"
          class="rounded-pill px-3 py-2 text-center border-0"
          @click="value = true"
        >
          {{ $t('plans.common.cards.annual') }}
          <strong>-{{ annualDiscount }}%</strong>
        </button>
      </div>
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: {
    annualDiscount: {
      type: Number,
      default: 25
    },
    backgroundColor: {
      type: String,
      default: '#f6f6f6'
    },
    pillColor: {
      type: String,
      default: 'transparent'
    },
    activePillColor: {
      type: String,
      default: '#3cd699'
    },
    activePillTextColor: {
      type: String,
      default: '#fff'
    },
    mobileBackgroundcolor: {
      type: String,
      default: '#f6f6f6'
    }
  },
  data() {
    return {
      value: true
    };
  },
  watch: {
    value(newValue) {
      this.$emit('switch-plans', newValue);
    }
  }
};
</script>

<style lang="scss" scoped>
button {
  background: transparent;
  margin: 5px;
}
.switch-margin {
  margin-top: 24px;
}
.switch-container {
  position: relative;
  align-items: center;
  justify-content: center;
  display: flex;
  border-radius: 50rem;
  background-color: var(--background);
  @include sm {
    background-color: var(--mobile-background);
  }
}
</style>
